import { __awaiter } from "tslib";
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "src/app/services/http-util.service";
export class CompanyService {
    constructor(http, httpUtilService) {
        this.http = http;
        this.httpUtilService = httpUtilService;
        this.logoCache = {};
    }
    // getCompanyLogo(companyId: number): Promise<Observable<HttpResponse<Object>>> {
    //   const self = this;
    //   const apiEndpoint = 'company/' + companyId + '/logo';
    //   return self.httpUtilService.invokeQuery('GET', null, apiEndpoint);
    // }
    clearCompanyLogoCache(companyId) {
        // Remove from memory cache
        if (this.logoCache[companyId]) {
            delete this.logoCache[companyId];
        }
        // Remove from localStorage
        localStorage.removeItem(`companyLogo_${companyId}`);
    }
    getCompanyLogo(companyId) {
        let api_host = environment.apiUrl;
        const apiEndpoint = api_host + `company/${companyId}/logo`;
        // Check memory cache first
        if (this.logoCache[companyId]) {
            return of(this.dataURItoBlob(this.logoCache[companyId]));
        }
        // Check localStorage
        const cachedLogo = localStorage.getItem(`companyLogo_${companyId}`);
        if (cachedLogo) {
            this.logoCache[companyId] = cachedLogo; // Store in memory
            return of(this.dataURItoBlob(cachedLogo));
        }
        // Fetch from API, store in cache
        return this.http.get(apiEndpoint, { responseType: 'blob' }).pipe(tap(blob => {
            this.cacheBlob(companyId, blob);
        }));
    }
    deleteCompanyLogo(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const self = this;
            const apiEndpoint = `company/${companyId}/logo`;
            return self.httpUtilService.invokeWithFormData('DELETE', null, apiEndpoint);
        });
    }
    deleteItemSkus(companyId, itemsToDelete) {
        return __awaiter(this, void 0, void 0, function* () {
            const self = this;
            const apiEndpoint = 'pharmacy/' + companyId + '/itemSkus';
            return self.httpUtilService.invokeWithFormData('DELETE', itemsToDelete, apiEndpoint);
        });
    }
    cacheBlob(companyId, blob) {
        const reader = new FileReader();
        reader.onloadend = () => {
            const dataUrl = reader.result;
            this.logoCache[companyId] = dataUrl;
            localStorage.setItem(`companyLogo_${companyId}`, dataUrl); // ✅ Store base64 data URI in localStorage
        };
        reader.readAsDataURL(blob);
    }
    dataURItoBlob(dataURI) {
        const byteString = atob(dataURI.split(',')[1]);
        const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], { type: mimeString });
    }
}
CompanyService.ɵfac = function CompanyService_Factory(t) { return new (t || CompanyService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.HttpUtilService)); };
CompanyService.ɵprov = i0.ɵɵdefineInjectable({ token: CompanyService, factory: CompanyService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(CompanyService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: i2.HttpUtilService }]; }, null); })();
//# sourceMappingURL=company.service.js.map